import { CrossSellingItemInstancePrice } from "./CrossSellingItemInstancePrice";
import { Price } from "./Price";
export const ProductCardCrossSellingCreatorPrice = {
    price,
};
function price(creator) {
    return Price.total(creator.items.map((crossSellingItemInstance) => CrossSellingItemInstancePrice.totalPrice(crossSellingItemInstance)));
}
